/**
 * `@loot-os/react/neon-pack`: the Neon Pack opener (a holo booster pack rips open on a synthwave
 * grid and its one card decrypts). It renders with three.js, so it ships on its own entry point
 * with `three`, `@react-three/fiber`, `@react-three/drei`, `@react-three/postprocessing` and
 * `postprocessing` as optional peer dependencies. A host that shows boxes whose opener style is
 * `neon_pack` calls `registerNeonPack()` once; the scene itself loads on first use.
 */
import { NEON_PACK_TOKENS } from "./openers/neonPack/tokens";
import { defineStageOpener, registerOpener } from "./openers/registration";

export const neonPackOpener = defineStageOpener(
  () => import("./openers/neonPack/NeonPackOpener"),
  NEON_PACK_TOKENS,
);

/** Registers Neon Pack for every opener on the page. Idempotent. */
export function registerNeonPack(): void {
  registerOpener("neon_pack", neonPackOpener);
}

export { NEON_PACK_TOKENS };
